import { useCallback } from "react";

import { useBlock } from "@/components/PowerBlock/Block/block-store";
import { MCPConfiguration } from "@/types/evaluate";

const useServerUrlInput = (blockStore: ReturnType<typeof useBlock<MCPConfiguration>>) => {
  const handleUrlChange = useCallback(
    (url: string) => {
      const trimmedUrl = url.trim();
      blockStore.setConfiguration({
        ...blockStore.configuration,
        server_configuration: {
          ...blockStore.configuration?.server_configuration,
          server_url: trimmedUrl,
          headers: blockStore.configuration?.server_configuration?.headers || {},
        },
      } as MCPConfiguration);
    },
    [blockStore],
  );

  return { handleUrlChange };
};

export default useServerUrlInput;
